import React from 'react'
import {withStyles} from '@material-ui/core';
import PropTypes from 'prop-types';
import Form from 'components/Form';
import positionTypes, {POSITION_TYPE} from './constants/additionalPositionType.values'
import TextInput from 'components/TextInput';
import Tr from 'translations/Translations';
import Select from 'components/Select';
import PartsTable from 'components/PartsTable';
import BooleanItems from 'constants/BooleanItems';
import validationSheme from './constants/validation.form'
import InputLimits from 'constants/InputLimits';
import getObjectValue from 'libs/getObjectValue';

const limits = InputLimits.procedure.parameters;

const style = theme => ({
	root: {

	},
	uploadFile: {
		marginBottom: theme.spacing(2)
	}
})

function AddAdditionalPositionForm({
	classes,
	onSubmit = () => { },
	id,
	initValues,
	partId,
	elementList,
	showParts = true,
}) {

	const getInitialValues = () => {
		if (initValues !== undefined) {
			return {
				...initValues,
				parts: {
					[partId]: true,
				}
			};
		}
		return {
			uiType: POSITION_TYPE.TEXT,
			showCommentField: null,
			description: '',
			name: '',
			parts: {
				[partId]: true,
			},
			attachments: null
		}
	}

	const getNames = () => {
		let elementId = elementList.findIndex((x) => x.identity === partId)
		let selected = elementList[elementId].stages[0].parameters.map(x => {
			return x.name;
		})
		if (initValues !== undefined) {
			let initValuesName = initValues.name;
			var index = selected.indexOf(initValuesName);
			if (index > -1) {
				selected.splice(index, 1);
			}
		}
		return selected;
	}

	return (
		<Form
			id={id}
			onSubmit={onSubmit}
			initialValues={{
				...getInitialValues(),
				_editable: showParts,
			}}
			validationSchema={validationSheme(getNames())}
		>
			{(formikProps) => (
				<>
					<TextInput
						id='name'
						formikProps={formikProps}
						label={Tr('position_name')}
						required
						limit={limits.NAME}
					/>
					<Select
						id={'uiType'}
						formikProps={formikProps}
						items={positionTypes}
						label={Tr('position_type')}
					/>
					<TextInput
						id='description'
						formikProps={formikProps}
						label={Tr('description')}
						multiline
					/>
					{getObjectValue('uiType', formikProps.values, false) === POSITION_TYPE.YES_NO &&
					<Select
						id='showCommentField'
						formikProps={formikProps}
						items={BooleanItems}
						required
						label={Tr('show_comment_field')}
					/>
					}
					{/*<Box component="div" className={classes.uploadFile}>
						<UploadFile
							id="attachments"
							formikProps={formikProps}
							label={Tr("attachment")}
						/>
					</Box>*/}
					{elementList.length > 1 &&
						<PartsTable
							id={'parts'}
							formikProps={formikProps}
							elementList={elementList}
						/>
					}
				</>
			)}
		</Form>
	)
}

AddAdditionalPositionForm.propTypes = {
	classes: PropTypes.any,
}

export default withStyles(style)(AddAdditionalPositionForm);